export default __webpack_public_path__ + "215c2cfe608a4daf0e2a4ca47ffaad34.svg";